import React, { useEffect, useState, useRef } from 'react';
import {
  MotifDropdown,
  MotifDropdownItem,
  MotifIcon,
  MotifBadge,
  MotifChip,
} from '@ey-xd/motif-react';
import {
  navigationIcArrowDropDown24px,
  navigationIcClose24px,
} from '@ey-xd/motif-react/assets/icons';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Account_List,
  Current_User,
  Recoil_All_Accounts_Quarter_State,
  Recoil_Quarter_State,
  Recoil_Selected_Account_State,
  System_Date_Time_State,
} from '../../../recoil/recoil';
import styled from 'styled-components';
import { getAlertBarDetails } from '../../../util/commonFunctions';
import iconAccount from '../../assets/icons/icAccount.png';
import iconPerson from '../../assets/icons/icPerson.png';
import exitApp from '../../assets/icons/exit_app.png';
import iconAccountSelected from '../../assets/icons/icAccountSelected.png';
import iconPersonSelected from '../../assets/icons/icPersonSelected.png';
import { useNavigate } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import SpinnerLoader from '../../atoms/SpinnerLoader';
import { getLogOutStatus } from '../../../services/commonServices';

function UserProfileDropdown(props) {
  const userAccountList = useRecoilValue(Account_List);
  const currentUser = useRecoilValue(Current_User);
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const allAccountsQuarterData = useRecoilValue(Recoil_All_Accounts_Quarter_State);
  const [flattenedAccountList, setflattenedAccountList] = useState(null);
  const [selectedUser, setSelectedUser] = useRecoilState(Recoil_Selected_Account_State);
  let [notForecastedAccountCount, setNotForecastedAccountCount] = useState(0);
  let [isOpen, setIsOpen] = useState(false);
  let [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  let [isHandleToggleJustUsed, setIsHandleToggleJustUsed] = useState(null);

  let onlyAccountList;
  let modifiedAccountList = [];
  let alertStatusDetails;
  let notDoneCount;
  let navigate = useNavigate();
  let timeoutId;

  useEffect(() => {
    if (
      userAccountList != null &&
      currentUser != null &&
      quarterData != null &&
      allAccountsQuarterData != null
    ) {
      notDoneCount = 0;
      onlyAccountList = userAccountList.reduce((result, item) => {
        item.accountList.forEach(account => {
          result.push({ role: item.role, ...account });
        });
        return result;
      }, []);

      onlyAccountList.forEach(account => {
        modifiedAccountList = [];

        let apiPayload = {
          email: currentUser.email,
          role: account.role,
          month: quarterData.month,
          year: quarterData.fiscal_year,
          accountId: account.account_id,
        };

        (async () => {
          try {
            alertStatusDetails = await getAlertBarDetails(
              allAccountsQuarterData[account.role],
              apiPayload,
              null,
              systemDateTime,
            );

            if (alertStatusDetails.userDropdownChip == 'Done') {
              notDoneCount += 1;
            }
            setNotForecastedAccountCount(notDoneCount);

            if (apiPayload.role == 'PL') {
              // Added bcoz backend is not sending name: PL,
              // comming in API name: N.A.
              modifiedAccountList.push({
                role: account.role,
                dueDetails: alertStatusDetails,
                accountName: 'Pursuit Leader',
                ...account,
              });
            } else if (apiPayload.role == 'GCSP') {
              modifiedAccountList.push({
                role: account.role,
                dueDetails: alertStatusDetails,
                accountName: `GCSP: ${account.name}`,
                ...account,
              });
            } else {
              modifiedAccountList.push({
                role: account.role,
                dueDetails: alertStatusDetails,
                accountName: account.name,
                ...account,
              });
            }
          } catch (error) {
            console.error('Error fetching forecast submit status:', error);
          }
        })();
      });

      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setflattenedAccountList(modifiedAccountList);
        if (!!localStorage.getItem('selectedUser')) {
          const previouslySelectedUser = JSON.parse(localStorage.getItem('selectedUser'));

          const isUserExist = modifiedAccountList.some(
            obj => obj.account_id === previouslySelectedUser?.account_id,
          );

          if (isUserExist) {
            setSelectedUser(previouslySelectedUser);
          } else {
            handleLogoutButtonClick();
          }
        } else {
          setSelectedUser(modifiedAccountList[0]);
          localStorage.setItem('selectedUser', JSON.stringify(modifiedAccountList[0]));
        }
        setIsLoading(false);
      }, 3000);
    }
  }, [
    userAccountList,
    currentUser,
    quarterData,
    allAccountsQuarterData,
    localStorage.getItem('selectedUser'),
  ]);

  const handleToggle = type => {
    let timeoutId;
    if (type == 'toggle') {
      setIsOpen(!isOpen);
      setIsHandleToggleJustUsed(true);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsHandleToggleJustUsed(null);
      }, 100);
    } else {
      if (isHandleToggleJustUsed == null) {
        setIsOpen(false);
        setIsHandleToggleJustUsed(null);
      }
    }
  };

  const getUserIcon = (account, isOnNavbar) => {
    if (account.role == 'PL') {
      if (isOnNavbar) return iconPerson;

      if (selectedUser && selectedUser.account_id === account.account_id) return iconPersonSelected;
      else return iconPerson;
    } else {
      if (isOnNavbar) return iconAccount;

      if (selectedUser && selectedUser.account_id === account.account_id)
        return iconAccountSelected;
      else return iconAccount;
    }
  };
  const getUserForecastDueInfo = dueDetails => {
    const chipStyle = {
      color: '#ffffff',
    };
    const shouldApplyStyle =
      dueDetails.userDropdownChip === 'Submitted' || dueDetails.userDropdownChip === 'Missed';
    const chipType =
      dueDetails.userDropdownChip === 'Submitted' || dueDetails.userDropdownChip === 'Missed'
        ? 'outlined'
        : undefined;

    const isOpensOn =
      dueDetails.userDropdownChip.includes('Opens on') ||
      dueDetails.userDropdownChip.includes('Due on');
    const variant = isOpensOn ? 'monochrome-dark' : dueDetails.type;

    return (
      <MotifChip variant={variant} type={chipType} style={shouldApplyStyle ? chipStyle : undefined}>
        {dueDetails.userDropdownChip}
      </MotifChip>
    );
  };

  const getNotForcastedCount = count => {
    return flattenedAccountList.length - count;
  };

  const onDropdownUserClicked = user => {
    setSelectedUser(user);
    setIsOpen(false);
    localStorage.setItem('selectedUser', JSON.stringify(user));
    navigate('/');
    window.location.reload();
  };

  const [ariaLabel, setAriaLabel] = useState('Count of Accounts');

  const announceCount = () => {
    const count = getNotForcastedCount(notForecastedAccountCount);
    const message = `count of accounts: ${count}`;
    setAriaLabel(message);
  };

  const handleLogoutButtonClick = () => {
    getLogOutStatus(currentUser.email)
      .then(result => {
        sessionStorage.removeItem('isPrivacyPopupClosedOnce');
        localStorage.clear();
        sessionStorage.clear();
        navigate('/logout');
      })

      .catch(error => {
        console.error('Error logging out:', error);
      });
  };

  const DesktopUserDropdown = () => {
    const dropdownRef = useRef();
    const [focusedIndex, setFocusedIndex] = useState(-1);

    useEffect(() => {
      if (focusedIndex !== -1 && dropdownRef.current) {
        dropdownRef.current.children[focusedIndex].focus();
      }
    }, [focusedIndex]);

    const handleKeyDown = event => {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          setFocusedIndex(prevIndex =>
            prevIndex < flattenedAccountList.length - 1 ? prevIndex + 1 : prevIndex,
          );
          break;
        case 'ArrowUp':
          event.preventDefault();
          setFocusedIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : 0));
          break;
        case 'Enter':
          if (focusedIndex !== -1) {
            onDropdownUserClicked(flattenedAccountList[focusedIndex]);
          }
          break;
        default:
          break;
      }
    };

    return (
      <>
        {flattenedAccountList != null &&
          currentUser != null &&
          quarterData != null &&
          selectedUser != null && (
            <div className="motif-col-xs-1">
              <MotifDropdown
                ref={dropdownRef}
                open={isOpen}
                id="dropdown"
                aria-labelledby="dropdown-trigger"
                handleClickOutside={() => {
                  handleToggle('outsideClick');
                }}
                trigger={
                  <>
                    <DropdownDisplayContainer
                      onClick={() => {
                        handleToggle('toggle');
                      }}
                      onKeyDown={handleKeyDown}
                      tabIndex="0"
                      id="dropdown-trigger"
                    >
                      <DropdownIconContainer>
                        {' '}
                        <img
                          src={getUserIcon(selectedUser, true)}
                          alt=""
                          style={{ width: '16px', height: '16px' }}
                        />
                      </DropdownIconContainer>

                      <DropdownTextContainer>
                        {selectedUser.accountName.length < 20
                          ? selectedUser.accountName
                          : `${selectedUser.accountName.slice(0, 20)}...`}
                      </DropdownTextContainer>
                      <DropdownDueContainer>
                        <MotifBadge
                          variant="error"
                          value={getNotForcastedCount(notForecastedAccountCount)}
                          style={{
                            width: '19px',
                            height: '19px',
                            padding: '2px 5px 2px 5px',
                            borderRadius: '12px',
                            gap: '6px',
                            color: '#1A1A24',
                            backgroundColor: '#F95D54',
                          }}
                          aria-label={ariaLabel}
                          onMouseOver={announceCount}
                        >
                          <span aria-hidden="true">
                            {getNotForcastedCount(notForecastedAccountCount)}
                          </span>
                        </MotifBadge>
                        <MotifIcon src={navigationIcArrowDropDown24px} />
                      </DropdownDueContainer>
                    </DropdownDisplayContainer>
                  </>
                }
              >
                {flattenedAccountList.map((account, index) => (
                  <StyledDropdownItem
                    key={index}
                    // style={{ backgroundColor: '#2e2e38' }}
                    onClick={() => onDropdownUserClicked(account)}
                    selected={selectedUser && selectedUser.account_id === account.account_id}
                  >
                    <DropdownContainer>
                      <UserIconContainer>
                        <img
                          src={getUserIcon(account)}
                          alt=""
                          style={{ width: '16px', height: '16px' }}
                        />
                      </UserIconContainer>
                      <UserTextContainer
                        selected={selectedUser && selectedUser.account_id === account.account_id}
                      >
                        {account.accountName.length < 13
                          ? account.accountName
                          : `${account.accountName.slice(0, 13)}...`}
                      </UserTextContainer>
                      <DueTextContainer>
                        {getUserForecastDueInfo(account.dueDetails)}
                      </DueTextContainer>
                    </DropdownContainer>
                  </StyledDropdownItem>
                ))}
                <StyledDropdownItem onClick={handleLogoutButtonClick}>
                  <UserIconContainer style={{ marginRight: '10px' }}>
                    <img src={exitApp} alt="" style={{ width: '16px', height: '16px' }} />
                  </UserIconContainer>
                  <UserTextContainer style={{ marginLeft: '5px' }}>LOGOFF</UserTextContainer>
                </StyledDropdownItem>
              </MotifDropdown>
            </div>
          )}
      </>
    );
  };

  const toggleDrawer = () => {
    setIsUserDropdownOpen(isUserDropdownOpen => !isUserDropdownOpen);
  };

  const MobileUserDropdown = () => {
    return (
      <>
        {' '}
        <MobileUserProfileButton src={iconPerson} onClick={toggleDrawer} />
        <Drawer
          className="userprofile-drawer"
          duration={250}
          onClose={toggleDrawer}
          direction="right"
          open={isUserDropdownOpen}
          overlayOpacity="0.6"
          zIndex={100}
          size={isTablet ? '40vw' : '80vw'}
          style={{ backgroundColor: '#1a1a24' }}
        >
          {isLoading ? (
            <div style={{ position: 'fixed', top: '50%', left: '50%' }}>
              <SpinnerLoader color="#ffffff" />
            </div>
          ) : (
            <>
              <CloseIconContainer>
                <MotifIcon
                  src={navigationIcClose24px}
                  style={{ position: 'absolute', right: '10px', top: '10px' }}
                  onClick={toggleDrawer}
                />
              </CloseIconContainer>
              {flattenedAccountList != null &&
                currentUser != null &&
                quarterData != null &&
                selectedUser != null && (
                  <>
                    <PagesText>SWITCH ROLE</PagesText>

                    {flattenedAccountList.map((account, index) => (
                      <StyledDropdownItem
                        key={index}
                        // style={{ backgroundColor: '#2e2e38' }}
                        onClick={() => onDropdownUserClicked(account)}
                        selected={selectedUser && selectedUser.account_id === account.account_id}
                      >
                        <DropdownContainer style={{ width: '100%' }}>
                          <UserIconContainer>
                            <img
                              src={getUserIcon(account)}
                              alt=""
                              style={{ width: '16px', height: '16px' }}
                            />
                          </UserIconContainer>
                          <UserTextContainer
                            selected={
                              selectedUser && selectedUser.account_id === account.account_id
                            }
                          >
                            {account.accountName.length < 13
                              ? account.accountName
                              : `${account.accountName.slice(0, 13)}...`}
                          </UserTextContainer>
                          <DueTextContainer>
                            {getUserForecastDueInfo(account.dueDetails)}
                          </DueTextContainer>
                        </DropdownContainer>
                      </StyledDropdownItem>
                    ))}
                    <StyledDropdownItem onClick={handleLogoutButtonClick}>
                      <DropdownContainer style={{ width: '100%' }}>
                        <UserIconContainer>
                          <img src={exitApp} alt="" style={{ width: '16px', height: '16px' }} />
                        </UserIconContainer>
                        <UserTextContainer>LOGOFF</UserTextContainer>
                        <DueTextContainer />
                      </DropdownContainer>
                    </StyledDropdownItem>
                  </>
                )}
            </>
          )}
        </Drawer>
      </>
    );
  };

  return <>{isMobile ? <MobileUserDropdown /> : <DesktopUserDropdown />}</>;
}

export default UserProfileDropdown;

const DropdownDisplayContainer = styled.div`
  display: grid;
  grid-template-columns: 20px;
  grid-auto-columns: auto;
  grid-auto-flow: column;
  grid-column-gap: 8px;
  width: 295px;
  height: 56px;
  padding: 0 10px;
  border-left: 3px solid #3a3a4a;
  align-items: center;

  &:focus {
    border-top: 1px solid #ffffff;
    border-bottom: 1px solid #ffffff;
    border-left: 1px solid #ffffff;
    border-right: 1px solid #ffffff;
  }
`;

const DropdownIconContainer = styled.div`
  width: 20px;
`;

const DropdownTextContainer = styled.div`
  text-align: left;
  width: 120px;
  color: #fff;
`;

const DropdownDueContainer = styled.div`
  height: 56px;
  display: flex;
  flex-direction: row;
  padding-left: 10px;
  justify-self: end;
  align-items: center;
  border-left: 3px solid #3a3a4a;
`;

const DropdownContainer = styled.div`
  display: grid;
  grid-template-columns: ${isMobile ? '1fr 4fr 3fr' : '20px 110px 110px'};
  gap: 10px;
  align-items: center;
  width: ${isMobile ? 'auto' : '280px'};
`;

const UserIconContainer = styled.div`
  width: 15px;
`;

const UserTextContainer = styled.div`
  text-align: left;
  width: 90px;
  color: #fff;

  ${({ selected }) => selected && `color: yellow;`}
`;

const DueTextContainer = styled.div`
  width: ${isMobile ? 'auto' : '125px'};
`;

const StyledDropdownItem = styled(MotifDropdownItem)`
  background-color: ${isMobile ? '#1a1a24' : '#2e2e3c'};
  transition: background-color 0.3s;
  &:hover {
    background-color: ${isMobile ? '#2e2e3c' : '#1a1a24'};
    cursor: pointer;
  }

  // 2e2e3c faint
  // 2e2e3c dark

  ${({ selected }) =>
    selected &&
    `background-color: #1A1A24;
     &:hover {
     background-color: #1A1A24;
    }`}
`;

const MobileUserProfileButton = styled.img`
  width: 25px;
  height: 25px;
  margin-top: 15px;
  margin-right: 10px;
`;

export const PagesText = styled.div`
  padding: 10px 0px 10px 20px;
  background-color: #2e2e38;
`;

export const CloseIconContainer = styled.div`
  position: relative;
  margin-bottom: 50px;
`;
